import { FC } from "react";
import { View } from "react-native";

import { tailwind } from "src/foundations/styles";

export const AccordionDetails: FC<{ noBottomPadding?: boolean }> = ({
  children,
  noBottomPadding,
}) => {
  return <View style={noBottomPadding ? tailwind("pt-2") : tailwind("pt-2 pb-6")}>{children}</View>;
};

export default AccordionDetails;
